/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-confusing-arrow */
/* eslint-disable import/no-cycle */
/* eslint-disable indent */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable quotes */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable spaced-comment */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-use-before-define */
/* eslint-disable no-param-reassign */

import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

interface CustomProperties {
    [key: string]: any;
}

class AppInsightsService {
    private static _instance: AppInsightsService | null = null;

    private appInsights: ApplicationInsights;

    private reactPlugin: ReactPlugin;

    private initialized: boolean = false;

    private constructor() {
        const browserHistory = createBrowserHistory();
        this.reactPlugin = new ReactPlugin();

        this.appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: process.env.REACT_APP_APPINSIGHTS_KEY,
                extensions: [this.reactPlugin],
                extensionConfig: {
                    [this.reactPlugin.identifier]: { history: browserHistory }
                },
                enableAutoRouteTracking: true,
                enableCorsCorrelation: true,
                enableRequestHeaderTracking: true,
                enableResponseHeaderTracking: true,
                enableAjaxPerfTracking: true,
                disableFetchTracking: false,
                enableUnhandledPromiseRejectionTracking: true,
                maxBatchSizeInBytes: 5120000,
                maxBatchInterval: 15000,
                disableExceptionTracking: false,
                // disableAnalytics: false,
                autoTrackPageVisitTime: true,
            }
        });
    }

    public static getInstance(): AppInsightsService {
        if (AppInsightsService._instance === null) {
            AppInsightsService._instance = new AppInsightsService();
        }
        return AppInsightsService._instance;
    }

    public initialize(): void {
        if (!this.initialized) {
            this.appInsights.loadAppInsights();
            this.addCustomTelemetryInitializer();
            this.setupGlobalErrorHandling();
            this.trackInitialPageView();
            this.initialized = true;
        }
    }

    private addCustomTelemetryInitializer(): void {
        this.appInsights.addTelemetryInitializer((envelope) => {
            const customProperties = {
                environment: process.env.NODE_ENV,
                appVersion: process.env.REACT_APP_VERSION,
                userAgent: navigator.userAgent,
            };
            if (envelope.data) {
                envelope.data = { ...envelope.data, ...customProperties };
            }
        });
    }

    private setupGlobalErrorHandling(): void {
        window.onerror = (message, source, lineno, colno, error) => {
            this.trackException(error || new Error(message as string));
            return false;
        };

        window.onunhandledrejection = (event) => {
            this.trackException(event.reason || new Error('Unhandled Promise rejection'));
        };
    }

    private trackInitialPageView(): void {
        const currentPage = window.location.pathname + window.location.search;
        this.trackPageView(currentPage);
    }

    public trackPageView(pageTitle?: string, customProperties?: CustomProperties): void {
        if (this.initialized) {
            this.appInsights.trackPageView({
                name: pageTitle,
                properties: customProperties
            });
        }
    }

    public trackEvent(name: string, customProperties?: CustomProperties): void {
        if (this.initialized) {
            this.appInsights.trackEvent({ name }, customProperties);
        }
    }

    public trackException(error: Error, customProperties?: CustomProperties): void {
        if (this.initialized) {
            this.appInsights.trackException({
                error,
                properties: customProperties
            });
        }
    }

    public trackMetric(name: string, average: number, customProperties?: CustomProperties): void {
        if (this.initialized) {
            this.appInsights.trackMetric({ name, average }, customProperties);
        }
    }

    public trackApiCall(
        method: string,
        url: string,
        duration: number,
        success: boolean,
        resultCode: number
    ): void {
        if (this.initialized) {
            this.trackEvent('ApiCall', {
                method,
                url,
                duration,
                success,
                resultCode
            });
        }
    }

    public setAuthenticatedUserContext(userId: string, accountId?: string): void {
        if (this.initialized) {
            this.appInsights.setAuthenticatedUserContext(userId, accountId);
        }
    }

    public clearAuthenticatedUserContext(): void {
        if (this.initialized) {
            this.appInsights.clearAuthenticatedUserContext();
        }
    }
}

// Create and export a single instance
export const appInsightsService = AppInsightsService.getInstance();
